import React, { PureComponent } from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { Avatar } from 'common';
import { Box, Typography } from '@material-ui/core';
import './profileDropdown.scss';
import { ExitToApp, Tune } from '@material-ui/icons';

class ProfileDropdown extends PureComponent {
  constructor() {
    super();
    this.state = {
      anchorEl: null,
      open: false,
    };
  }

  handleToggle = (event = {}) => {
    if (event.currentTarget) {
      this.setState({
        anchorEl: event.currentTarget,
        open: true,
      });

      return true;
    }

    this.setState({
      open: false,
      anchorEl: null,
    });
  };

  handleClose = () => {
    this.handleToggle();
  };

  render() {
    const { userName, logout, changeLocation } = this.props;
    const { open, anchorEl } = this.state;

    return (
      <div>
        <div>
          <Avatar
            style={{
              width: '32px',
              height: '32px',
              fontSize: '1rem',
            }}
            name={userName}
            onClick={this.handleToggle}
            className="user-avatar"
          />
          <Popper
            open={open}
            anchorEl={anchorEl}
            role={undefined}
            placement={'bottom-end'}
            transition
            disablePortal
            modifiers={{
              offset: '10px -15px',
            }}
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps}>
                <Paper className="profile-menu">
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <MenuList autoFocusItem={open} id="menu-list-grow">
                      <Box className="signed-in-as">
                        <Typography className="signed-in-as-label">
                          Signed in as
                        </Typography>
                        <Typography className="signed-in-as-username">
                          {userName}
                        </Typography>
                      </Box>
                      <hr />
                      <MenuItem
                        className="menu-item"
                        onClick={changeLocation('/integrations')}
                      >
                        <Tune className="menu-item-icon" /> Apps & Integrations
                      </MenuItem>
                      <MenuItem className="menu-item" onClick={logout}>
                        <ExitToApp className="menu-item-icon" /> Log out
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
    );
  }
}

export default ProfileDropdown;
